import React from 'react';
import { useTranslation } from 'react-i18next';
import './DonationList.css';

const DonationList: React.FC = () => {
  const { t } = useTranslation();

  const donations = [
    {
      name: t('donationList.donations.donation1.name'),
      amount: t('donationList.donations.donation1.amount'),
      date: t('donationList.donations.donation1.date'),
      cause: t('donationList.donations.donation1.cause')
    },
    {
      name: t('donationList.donations.donation2.name'),
      amount: t('donationList.donations.donation2.amount'),
      date: t('donationList.donations.donation2.date'),
      cause: t('donationList.donations.donation2.cause')
    },
    {
      name: t('donationList.donations.donation3.name'),
      amount: t('donationList.donations.donation3.amount'),
      date: t('donationList.donations.donation3.date'),
      cause: t('donationList.donations.donation3.cause')
    },
    {
      name: t('donationList.donations.donation4.name'),
      amount: t('donationList.donations.donation4.amount'),
      date: t('donationList.donations.donation4.date'),
      cause: t('donationList.donations.donation4.cause')
    },
    {
      name: t('donationList.donations.donation5.name'),
      amount: t('donationList.donations.donation5.amount'),
      date: t('donationList.donations.donation5.date'),
      cause: t('donationList.donations.donation5.cause')
    }
  ];

  return (
    <div className="donation-list-page">
      <div className="donation-list-hero">
        <div className="container">
          <h1 className="page-title">{t('donationList.title')}</h1>
        </div>
      </div>

      <section className="donation-list-section">
        <div className="container">
          <p className="donation-list-intro">{t('donationList.intro')}</p>
          
          <div className="donation-table-container">
            <table className="donation-table">
              <thead>
                <tr>
                  <th>{t('donationList.table.name')}</th>
                  <th>{t('donationList.table.amount')}</th>
                  <th>{t('donationList.table.date')}</th>
                  <th>{t('donationList.table.cause')}</th>
                </tr>
              </thead>
              <tbody>
                {donations.map((donation, index) => (
                  <tr key={index}>
                    <td>{donation.name}</td>
                    <td className="donation-amount">{donation.amount}</td>
                    <td>{donation.date}</td>
                    <td>{donation.cause}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DonationList;









